import { css } from "../../../styled-system/css";

export const styles = {
  outer: () =>
    css({
      position: "relative",
      paddingX: "baseUnit.mobile2",
      tablet: {
        paddingTop: "66px",
        maxWidth: "944px",
        margin: "0 auto",
      },
    }),
  card: () =>
    css({
      backgroundColor: "black",
      borderRadius: "baseUnit.mobile4",
      padding: "baseUnit.mobile4",
      display: "flex",
      flexDirection: "column",
      gap: "baseUnit.mobile2",
    }),
  taglineWrapper: () =>
    css({
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      paddingX: "baseUnit.mobile2",
    }),
  tagline: () =>
    css({
      fontSize: "body.shrimp",
      fontWeight: 700,
      lineHeight: "body.shrimp",
      letterSpacing: "body.shrimp",
      color: "white",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      margin: 0,
      tablet: {
        fontSize: "body.mouse",
        lineHeight: "body.mouse",
        letterSpacing: "body.mouse",
      },
    }),
  statList: () =>
    css({
      listStyle: "none",
      padding: 0,
      margin: 0,
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
      columnGap: "baseUnit.mobile1",
      rowGap: "baseUnit.mobile3",
      tablet: {
        gridTemplateColumns: "repeat(4, 1fr)",
        columnGap: "baseUnit.mobile2",
        rowGap: 0,
      },
    }),
  statItem: () =>
    css({
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: "4px",
      alignItems: "center",
      textAlign: "center",
    }),
  statValue: css({
    display: "block",
    fontSize: "heading.H2_alt.mobile",
    fontWeight: 800,
    lineHeight: "heading.H2_alt.mobile",
    letterSpacing: "heading.H2_alt.mobile",
    color: "white",
    width: "100%",
    "&[data-completed]": {
      color: "voltGreen",
    },
  }),
  statLabel: () =>
    css({
      display: "block",
      fontSize: "body.butterfly",
      fontWeight: 400,
      lineHeight: "body.butterfly",
      letterSpacing: "body.butterfly",
      color: "white",
    }),
  statValueSemantic: () =>
    css({
      position: "absolute",
      width: "1px",
      height: "1px",
      padding: 0,
      margin: "-1px",
      overflow: "hidden",
      clip: "rect(0,0,0,0)",
      whiteSpace: "nowrap",
      borderWidth: 0,
    }),
  imageWrapper: () =>
    css({
      position: "absolute",
      right: "44px",
      bottom: 0,
      width: "80px",
      height: "101px",
      pointerEvents: "none",
      tablet: {
        right: "55px",
        bottom: "auto",
        top: 0,
        width: "176px",
        height: "222px",
      },
    }),
};
